/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Maintainer_NameInputs */

const en_contact_maintainer_name = /** @type {(inputs: Contact_Maintainer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maintainer`)
};

const ko_contact_maintainer_name = /** @type {(inputs: Contact_Maintainer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`운영자`)
};

const ja_contact_maintainer_name = /** @type {(inputs: Contact_Maintainer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`運営者`)
};

/**
* | output |
* | --- |
* | "Maintainer" |
*
* @param {Contact_Maintainer_NameInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const contact_maintainer_name = /** @type {((inputs?: Contact_Maintainer_NameInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Maintainer_NameInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_maintainer_name(inputs)
	if (locale === "ko") return ko_contact_maintainer_name(inputs)
	return ja_contact_maintainer_name(inputs)
});